import { render, staticRenderFns } from "./JobPageStats.vue?vue&type=template&id=47ef6b1c&scoped=true"
import script from "./JobPageStats.vue?vue&type=script&lang=js"
export * from "./JobPageStats.vue?vue&type=script&lang=js"
import style0 from "./JobPageStats.vue?vue&type=style&index=0&id=47ef6b1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef6b1c",
  null
  
)

export default component.exports